import React, {
  createContext,
  FC,
  ReactNode,
  useCallback,
  useContext,
  useState
} from 'react'

import { Modal, Sizes } from '@components/modal'

interface ModalContextData {
  showModal: (options: ModalOptions) => void
  closeModal: () => void
}

const ModalContext = createContext<ModalContextData>({} as ModalContextData)

interface ModalOptions {
  content: ReactNode
  shouldCloseOnEsc?: boolean
  shouldCloseOnOverlayClick?: boolean
  onClose?: () => void
  size?: Sizes
  title: string
}

export const ModalProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [options, setOptions] = useState<ModalOptions>()

  const showModal = useCallback((options: ModalOptions): void => {
    document.querySelector('body').classList.toggle('overflow-hidden')
    setOptions(options)
  }, [])

  const closeModal = useCallback(() => {
    document.querySelector('body').classList.toggle('overflow-hidden')
    setOptions(undefined)
    if (options?.onClose) {
      options.onClose()
    }
  }, [options])

  return (
    <ModalContext.Provider value={{ showModal, closeModal }}>
      {children}
      <Modal
        content={options?.content}
        onRequestClose={closeModal}
        size={options?.size}
        shouldCloseOnEsc={options?.shouldCloseOnEsc}
        shouldCloseOnOverlayClick={options?.shouldCloseOnOverlayClick}
        title={options?.title}
      />
    </ModalContext.Provider>
  )
}

export const useModal = (): ModalContextData => {
  const context = useContext(ModalContext)
  if (!context) {
    throw new Error('o useModal deve ser utilizado dentro de um ModalProvider')
  }
  return context
}
